import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const productListRouteRef = createRouteRef();
export const productDashboardRouteRef = createRouteRef({
  params: ['productId'],
});
export const productCreateRouteRef = createRouteRef();
export const tenantJoinRequestRouteRef = createRouteRef();
export const runtimeEnvironmentRouteRef = createRouteRef({
  params: ['orchWorkspaceId', 'runtimeId'],
});
export const addRuntimeEnvironmentRouteRef = createRouteRef();
export const productEditRequestRouteRef = createRouteRef();
export const requestListRouteRef = createRouteRef();
